import React, { ChangeEvent } from 'react'

export interface CheckboxProps {
    name: string;
    label: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    isChecked?: boolean;
    hideLabel?: boolean;
    className?: string
}

export const Checkbox = ({
    name,
    label,
    onChange,
    isChecked = false,
    hideLabel = false,
    className = '',
}: CheckboxProps) => (
    <div className={`form-check custom-checkbox ${className}`}>
        <input
            checked={isChecked}
            type="checkbox"
            id={name}
            onChange={onChange}
            className="custom-control-input"
        />
        <label htmlFor={name} className="custom-control-label">
            {! hideLabel && label}
        </label>
    </div>
)
